module.exports = __webpack_public_path__ + "6741e8b187beee6426da12c84ae4f569.svg";